import { Info } from "@assets";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall, Caption } from "@components/Typography";
import { i18n, Translations } from "@i18n";
import { useStyles } from "./styles";
import { TaxFilingInfoCardProps } from "./types";

export const TaxFilingInfoCard = ({ style }: TaxFilingInfoCardProps) => {
  const { styles, iconFill } = useStyles();

  return (
    <div style={{ ...styles.card, ...style }}>
      <div style={styles.iconColumn}>
        <Info size={16} fill={iconFill} />
      </div>
      <div style={styles.content}>
        <Caption style={styles.title}>{i18n.t(Translations.EditGoalRouteTaxFilingTitle)}</Caption>
        <Spacing size={SpacingSizes.S} />
        <BodySmall style={styles.body}>{i18n.t(Translations.EditGoalRouteTaxFilingBody)}</BodySmall>
        <Spacing size={SpacingSizes.S} />
        <Caption style={styles.disclaimer}>
          {i18n.t(Translations.EditGoalRouteTaxFilingDisclaimer)}
        </Caption>
      </div>
    </div>
  );
};
